/**
 * Touch screens (coarse pointer) get 40 px targets; mouse users keep the
 * compact 32 px row. Arbitrary variant, because Tailwind 3 has no
 * pointer-coarse modifier.
 */
export const COARSE_TARGET = '[@media(pointer:coarse)]:h-10 [@media(pointer:coarse)]:min-w-[40px]';
/** For square icon buttons that set an explicit width. */
export const COARSE_SQUARE = '[@media(pointer:coarse)]:h-10 [@media(pointer:coarse)]:w-10';

/** Shared look of the small tool buttons under the composer. */
export const TOOL_BUTTON =
  'inline-flex h-8 flex-shrink-0 items-center gap-1.5 rounded-lg px-2 text-[13px] font-medium text-muted-foreground transition-colors ' +
  'hover:bg-muted hover:text-foreground active:bg-muted/80 ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:ring-offset-card ' +
  'disabled:pointer-events-none disabled:opacity-45 ' +
  COARSE_TARGET;

export const TOOL_ICON_BUTTON = `${TOOL_BUTTON} w-8 justify-center px-0 ${COARSE_SQUARE}`;

export const KBD =
  'hidden rounded border border-border bg-background px-1 font-sans text-[10px] font-medium leading-4 text-muted-foreground sm:inline-block';

export function isApplePlatform(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Mac|iPhone|iPad|iPod/.test(navigator.platform || navigator.userAgent || '');
}

/** "0:07", "1:42" */
export function formatElapsed(ms: number): string {
  const seconds = Math.max(0, Math.floor(ms / 1000));
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
}
